import { cloneElement, Children, FC } from 'react';

import { IPublisher } from '../../models';

import { groupByPropKey, injectPublishEvents } from './helpers';

export const Publisher: FC<IPublisher> = ({ callbacks, children, ...restProps }) => {
    if (!callbacks) return children;

    const child = Children.only(children);

    const groupedCallbacks = groupByPropKey(callbacks);

    const newProps = injectPublishEvents(groupedCallbacks, child.props);

    return cloneElement(child, {
        ...restProps,
        ...newProps,
    });
};
